import { mainWrapper2g92l9we8tsl3 as main } from './tcg-cares-apps/org/thecommunitygroupinc/cares/Main.mjs';
import './cryptography-kotlin-cryptography-provider-webcrypto.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
//region block: exports
export * from './tcg-cares-apps/org/thecommunitygroupinc/cares/Timezones.export.mjs';
//endregion
main();

//# sourceMappingURL=tcg-cares-apps.mjs.map
